var map = {
	"./administration-desktop.png": 508,
	"./administration-mobile.png": 3920,
	"./auditory-desktop.png": 1349,
	"./auditory-mobile.png": 1127,
	"./home-desktop.png": 9207,
	"./home-mobile.png": 6017,
	"./patient-desktop.png": 7289,
	"./patient-mobile.png": 803,
	"./reports-desktop.png": 7907,
	"./reports-mobile.png": 6197,
	"./schedule-desktop.png": 893,
	"./schedule-mobile.png": 6319,
	"./shield-desktop.png": 3077,
	"./shield-mobile.png": 903,
	"./statistics-desktop.png": 5071,
	"./statistics-mobile.png": 217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9898;